<template lang="pug">
	.editor-text-edit-container(v-if="showed" :style="containerStyle" v-pseudo-modal-name="'inline-text-edit'" @mousedown.stop @click.stop)
		textarea.editor-text-edit-textarea(
			ref="textarea"
			v-model="currentText"
			@input="onInput"
			@keydown="onKeydown"
		)
		.editor-text-edit-actions
			button.editor-text-edit-btn.apply-btn(
				type="button"
				title="Apply and close"
				@click.stop.prevent="applyAndClose"
			)
				i.fa.fa-check
			button.editor-text-edit-btn.reset-btn(
				type="button"
				title="Cancel and close"
				@click.stop.prevent="cancelAndClose"
			)
				i.fa.fa-times
</template>

<script>
	import Screen from './../../mixins/screen';
	import _ from 'lodash';
	import { Version } from '../../services/Version';
	import { Localization } from '../../services/Localization';

	export default {
		name: 'InlineTextEdit',
		mixins: [Screen],
		screen: {
			events: {
				"IFrame Data:HitElement": function(data) {

					if (this.showed && data?.screenCodename === this.screenCodename && data?.elementCodename === this.elementCodename) this.updatePosition(data.rect);

				},
				"IFrame Data:StartInlineTextEdit": function(data) {

					this.startEdit(data);

				},
				"Preview Zoom Changed,Preview Drag State Changed,Preview Size Changed,Layout Workspace Changed,Aside State Changed,Sub Aside State Changed": function() {

					if (this.showed) {

						this.$nextTick(() => {
							this.updatePosition();
						});

					}

				},
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'inline-text-edit') && this.showed) {

						this.applyAndClose();

					}

				},
				"Selected Version Switched": function() {

					if (this.showed) this.closeWithoutSave();

				},
				"Selected Creative Changed": function() {

					if (this.showed) this.closeWithoutSave();

				}
			}
		},
		data() {
			return {
				screenCodename: null,
				elementCodename: null,
				textCodename: null,
				locale: 'en',
				messageObject: {},
				initialText: '',
				currentText: '',
				lastIframeRelativeRect: null,
				position: {
					top: '0px',
					left: '0px'
				},
				debounceTimer: null
			};
		},
		computed: {
			containerStyle() {
				return {
					top: this.position.top,
					left: this.position.left
				};
			}
		},
		mounted() {

			this._onWindowResize = () => {

				if (this.showed) {

					this.updatePosition();

				}

			};

			window.addEventListener('resize', this._onWindowResize);

		},
		beforeDestroy() {

			if (this._onWindowResize) {

				window.removeEventListener('resize', this._onWindowResize);

			}

		},
		methods: {
			startEdit(data) {

				if (!data) return;

				this.screenCodename = data.screenCodename;
				this.elementCodename = data.elementCodename;
				this.textCodename = data.textCodename;
				this.locale = data.locale || 'en';
				this.messageObject = data.messageObject || {};
				this.initialText = data.text !== undefined ? data.text : '';
				this.currentText = this.initialText;
				this.lastIframeRelativeRect = data.rect;

				this.show();

				this.$nextTick(() => {

					this.updatePosition(data.rect);

					if (this.$refs.textarea) {

						this.$refs.textarea.focus();
						this.$refs.textarea.select();

					}

				});

			},
			updatePosition(iframeRelativeRect) {

				if (!iframeRelativeRect) iframeRelativeRect = this.lastIframeRelativeRect;
				if (!iframeRelativeRect) return;
				this.lastIframeRelativeRect = iframeRelativeRect;

				let iframe = document.querySelector('.preview-frame iframe') || document.querySelector('iframe');
				let iframeRect = iframe ? iframe.getBoundingClientRect() : { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };

				let baseWidth = (iframeRelativeRect.windowWidth && iframeRelativeRect.windowWidth > 0)
					? iframeRelativeRect.windowWidth
					: (iframe ? (iframe.offsetWidth || parseFloat(iframe.getAttribute('width')) || iframe.clientWidth || 0) : 0);

				let baseHeight = (iframeRelativeRect.windowHeight && iframeRelativeRect.windowHeight > 0)
					? iframeRelativeRect.windowHeight
					: (iframe ? (iframe.offsetHeight || parseFloat(iframe.getAttribute('height')) || iframe.clientHeight || 0) : 0);

				let scaleX = 1;
				let scaleY = 1;

				if (baseWidth > 0 && iframeRect.width > 0) {

					scaleX = iframeRect.width / baseWidth;

				}

				if (baseHeight > 0 && iframeRect.height > 0) {

					scaleY = iframeRect.height / baseHeight;

				}

				let screenRect = {
					top: iframeRect.top + iframeRelativeRect.top * scaleY,
					bottom: iframeRect.top + (iframeRelativeRect.top + iframeRelativeRect.height) * scaleY,
					left: iframeRect.left + iframeRelativeRect.left * scaleX,
					right: iframeRect.left + (iframeRelativeRect.left + iframeRelativeRect.width) * scaleX,
					width: iframeRelativeRect.width * scaleX,
					height: iframeRelativeRect.height * scaleY
				};

				let containerWidth = 280;
				let containerHeight = 66;

				if (this.$el) {

					containerWidth = this.$el.offsetWidth || containerWidth;
					containerHeight = this.$el.offsetHeight || containerHeight;

				}

				let margin = 10;
				let spaceAbove = screenRect.top;
				let spaceBelow = window.innerHeight - screenRect.bottom;

				let top;
				if (spaceAbove >= containerHeight + margin) {

					top = screenRect.top - containerHeight - margin;

				} else if (spaceBelow >= containerHeight + margin) {

					top = screenRect.bottom + margin;

				} else {

					if (spaceAbove >= spaceBelow) {

						top = Math.max(margin, screenRect.top - containerHeight - margin);

					} else {

						top = Math.min(window.innerHeight - containerHeight - margin, screenRect.bottom + margin);

					}

				}

				let left = screenRect.left + (screenRect.width - containerWidth) / 2;
				left = Math.max(margin, Math.min(window.innerWidth - containerWidth - margin, left));
				top = Math.max(margin, Math.min(window.innerHeight - containerHeight - margin, top));

				this.position.top = `${top}px`;
				this.position.left = `${left}px`;

			},
			onInput() {

				this.sendLiveUpdateToIFrame(this.currentText);
				this.scheduleServerSync(this.currentText);

			},
			// Сразу показываем изменение в превью, не дожидаясь ответа сервера (тот же формат, что и при изменении локализации версии)
			sendLiveUpdateToIFrame(text) {

				Broadcast.call("Send To iFrame", [{
					Localization: {
						[this.locale]: {
							[this.textCodename]: {...this.messageObject, codename: this.textCodename, message: text}
						}
					}
				}]);

			},
			scheduleServerSync(text) {

				if (this.debounceTimer) clearTimeout(this.debounceTimer);

				this.debounceTimer = setTimeout(() => {

					this.sendServerSync(text);

				}, 300);

			},
			sendServerSync(text) {

				let versionId = Version.SelectedVersion?.id;
				if (versionId && this.locale && this.textCodename) {

					Localization.changeLocalizationMessage(versionId, this.locale, this.textCodename, text);

				}

			},
			resetToInitial() {

				if (this.debounceTimer) clearTimeout(this.debounceTimer);

				this.currentText = this.initialText;
				this.sendLiveUpdateToIFrame(this.initialText);
				this.sendServerSync(this.initialText);

				if (this.$refs.textarea) {

					this.$refs.textarea.focus();
					this.$refs.textarea.select();

				}

			},
			onKeydown(e) {

				if (e.key === 'Escape') {

					e.preventDefault();
					e.stopPropagation();
					this.cancelAndClose();

				} else if (e.key === 'Enter' && !e.shiftKey) {

					e.preventDefault();
					e.stopPropagation();
					this.applyAndClose();

				}

			},
			applyAndClose() {

				if (!this.showed) return;

				if (this.debounceTimer) {

					clearTimeout(this.debounceTimer);
					this.debounceTimer = null;

				}

				let newText = this.currentText;
				this.sendLiveUpdateToIFrame(newText);
				this.sendServerSync(newText);

				this.hide();

			},
			cancelAndClose() {

				if (!this.showed) return;

				if (this.debounceTimer) {

					clearTimeout(this.debounceTimer);
					this.debounceTimer = null;

				}

				this.currentText = this.initialText;
				this.sendLiveUpdateToIFrame(this.initialText);
				this.sendServerSync(this.initialText);

				this.hide();

			},
			closeWithoutSave() {

				if (this.debounceTimer) {

					clearTimeout(this.debounceTimer);
					this.debounceTimer = null;

				}

				this.hide();

			}
		}
	};
</script>

<style lang="sass">

	.editor-text-edit-container
		position: fixed
		z-index: 100000
		display: flex
		align-items: flex-start
		gap: 6px
		padding: 6px
		background: #1e222d
		border: 1px solid #2ac0f3
		border-radius: 4px
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5)
		box-sizing: border-box
		font-family: Arial, sans-serif
		pointer-events: auto

		.editor-text-edit-textarea
			width: 240px
			min-height: 56px
			max-height: 180px
			background: #14171f
			color: #ffffff
			border: 1px solid rgba(255, 255, 255, 0.15)
			border-radius: 3px
			padding: 6px 8px
			font-family: inherit
			font-size: 15px
			line-height: 1.4
			resize: both
			outline: none
			box-sizing: border-box

			&:focus
				//border-color: #2ac0f3

		.editor-text-edit-actions
			display: flex
			flex-direction: column
			gap: 4px
			flex-shrink: 0

		.editor-text-edit-btn
			width: 26px
			height: 26px
			display: flex
			align-items: center
			justify-content: center
			background: rgba(255, 255, 255, 0.08)
			color: rgba(255, 255, 255, 0.7)
			border: 1px solid rgba(255, 255, 255, 0.15)
			border-radius: 3px
			cursor: pointer
			font-size: 13px
			line-height: 1
			padding: 0
			margin: 0
			box-sizing: border-box
			transition: all 0.15s ease
			flex-shrink: 0
			outline: none

			&:focus, &:active
				outline: none

			&::-moz-focus-inner
				border: 0

			&.apply-btn:hover
				background: #4dbd74
				color: #ffffff
				border-color: #4dbd74

			&.reset-btn:hover
				background: #e53935
				color: #ffffff
				border-color: #e53935

</style>
